import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popular-business-category-list',
  templateUrl: './popular-business-category-list.component.html',
  styleUrls: ['./popular-business-category-list.component.sass']
})
export class PopularBusinessCategoryListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
